import { render, staticRenderFns } from "./_copy_items_to_folder_modal.vue?vue&type=template&id=21ef39b1&scoped=true&"
import script from "./_copy_items_to_folder_modal.vue?vue&type=script&lang=js&"
export * from "./_copy_items_to_folder_modal.vue?vue&type=script&lang=js&"
import style0 from "./_copy_items_to_folder_modal.vue?vue&type=style&index=0&id=21ef39b1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ef39b1",
  null
  
)

export default component.exports